import { queryKeys } from 'queries/queryKeys'

export const useFolderKeys = (where: 'docs' | 'templates') => {
  const many =
    where === 'templates' ? queryKeys.TEMPLATE_FOLDERS : queryKeys.DOCUMENT_FOLDERS
  const single =
    where === 'templates' ? queryKeys.TEMPLATE_FOLDER : queryKeys.DOCUMENT_FOLDER
  return [many, single]
}
